import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Eye, EyeOff, Mail, Lock, ArrowLeft } from "lucide-react";
import { BASE_URL } from '../../apiConfig';
import { useAuth } from "../../context/AuthProvider";

export default function LoginPage() {
  const [showPassword, setShowPassword] = useState(false);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [remember, setRemember] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { login } = useAuth();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);

    try {
      const response = await fetch(BASE_URL + "/api/login", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ email, password }),
      });

      const data = await response.json();

      if (data.status === 200) {
        // const cookieOptions = { expires: 7 };
        // Cookies.set("WEB_STT", data.token, cookieOptions);
        // Cookies.set("user", JSON.stringify(data.data), cookieOptions);
        // Cookies.set("config", JSON.stringify(data.config), cookieOptions);
        login(data.data, data.token, data.config);
        navigate("/dashboard");
        setLoading(false);
      } else {
        setError(data.message || "خطأ في تسجيل الدخول");
        setLoading(false);
      }
    } catch (err) {
      setError("فشل الاتصال بالخادم");
      setLoading(false);
    } 
  };

  return (
    <div
      dir="rtl"
      className="min-h-screen bg-gradient-to-br from-[var(--color-primary-50)] via-white to-[var(--color-primary-50)] flex items-center justify-center p-4"
    >
      <div className="w-full max-w-lg">
        <div className="bg-white rounded-2xl shadow-2xl p-8 border border-gray-100">
          <div className="text-center mb-8">
            <div className="mx-auto w-14 h-14 bg-gradient-to-r from-[var(--color-primary-500)] to-[var(--color-primary-400)] rounded-2xl flex items-center justify-center mb-4 shadow-lg">
              <Lock className="w-6 h-6 text-white" />
            </div>
            <h1 className="text-xl font-bold text-gray-900 mb-2">مرحبًا بعودتك</h1>
            <p className="text-gray-600 text-sm">سجّل الدخول إلى حسابك للمتابعة</p>
          </div>

          <form onSubmit={handleSubmit} className="space-y-6">
            {error && (
              <div className="text-red-600 bg-red-100 border border-red-300 px-4 py-2 rounded-lg text-xs text-center">
                {error}
              </div>
            )}

            <div>
              <label htmlFor="email" className="block text-xs font-semibold text-gray-700 mb-2">
                البريد الإلكتروني
              </label>
              <div className="relative">
                <Mail className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-4 h-4" />
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className="w-full text-xs pr-10 pl-4 py-3 border border-gray-200 rounded-xl outline-none focus:ring-[var(--color-primary-300)] focus:ring-2  focus:border-transparent transition-all duration-200 bg-gray-50 focus:bg-white"
                  placeholder="أدخل بريدك الإلكتروني"
                  required
                />
              </div>
            </div>

            <div>
              <label htmlFor="password" className="block text-xs font-semibold text-gray-700 mb-2">
                كلمة المرور
              </label>
              <div className="relative">
                <Lock className="absolute right-3 top-1/2 transform -translate-y-1/2  text-gray-400 w-4 h-4" />
                <input
                  type={showPassword ? "text" : "password"}
                  id="password"
                  name="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  className="w-full text-xs pr-10 pl-12 py-3 border border-gray-200 rounded-xl outline-none focus:ring-2 focus:ring-[var(--color-primary-300)] focus:border-transparent transition-all duration-200 bg-gray-50 focus:bg-white"
                  placeholder="أدخل كلمة المرور"
                  required
                />
                <button
                  type="button"
                  onClick={() => setShowPassword(!showPassword)}
                  className="absolute cursor-pointer left-3 top-1/2 transform -translate-y-1/2 text-gray-400 hover:text-gray-600"
                >
                  {showPassword ? <EyeOff className="w-4 h-4" /> : <Eye className="w-4 h-4" />}
                </button>
              </div>
            </div>

            <div className="flex items-center justify-between">
              <label className="flex items-center">
                <input
                  type="checkbox"
                  name="remember"
                  checked={remember}
                  onChange={(e) => setRemember(e.target.checked)}
                  className="w-4 h-4 text-blue-600 border-gray-300 rounded focus:ring-[var(--color-primary-300)]"
                />
                <span className="mr-2 text-xs text-gray-600">تذكرني</span>
              </label>
              <a
                href="/forgot-password"
                className="text-xs text-[var(--color-primary-500)] hover:text-[var(--color-primary-400)] font-medium"
              >
                نسيت كلمة المرور؟
              </a>
            </div>

            <button
              type="submit"
              disabled={loading}
              className={`w-full text-xs bg-gradient-to-r from-[var(--color-primary-500)] cursor-pointer to-[var(--color-primary-400)] text-white py-3 px-4 rounded-xl font-semibold flex items-center justify-center group shadow-lg transition-all duration-200 ${
                loading
                  ? "opacity-60 cursor-not-allowed"
                  : "hover:from-[var(--color-primary-400)] hover:to-[var(--color-primary-500)]"
              }`}
            >
              {loading ? (
                <svg
                  className="animate-spin h-4 w-4 text-white"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                >
                  <circle
                    className="opacity-25"
                    cx="12"
                    cy="12"
                    r="10"
                    stroke="currentColor"
                    strokeWidth="4"
                  ></circle>
                  <path
                    className="opacity-75"
                    fill="currentColor"
                    d="M4 12a8 8 0 018-8v4l3-3-3-3v4a8 8 0 00-8 8z"
                  ></path>
                </svg>
              ) : (
                <>
                  تسجيل الدخول
                  <ArrowLeft className="mr-2 w-4 h-4 group-hover:-translate-x-1 transition-transform duration-200" />
                </>
              )}
            </button>
          </form>

          <div className="mt-8 text-center">
            <p className="text-gray-600 text-xs">
              لا تملك حسابًا؟{" "}
              <a
                href="/register"
                className="text-[var(--color-primary-500)] hover:text-[var(--color-primary-400)] font-semibold"
              >
                أنشئ حسابًا مجانًا
              </a>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
